import React from 'react';
import PropTypes from 'prop-types';
import Column from '../Column';
import './style.css';
import logo from './logo.svg';

const Hero = ({
  image,
  text,
}) => (
  <div className="hero">
    <div className="hero__content">
      <Column>
        <img className="hero__logo" src={logo} alt="NOSop3" height="24" width="90" />
        <h1 className="hero__text">{text}</h1>
      </Column>
    </div>
  </div>
);

Hero.propTypes = {
  image: PropTypes.string,
  text: PropTypes.string.isRequired,
};

export default Hero;



// WEBPACK FOOTER //
// ./src/components/Hero/index.js